import { render, staticRenderFns } from "./ResponsiveYouTube.vue?vue&type=template&id=3881dedb&scoped=true&"
import script from "./ResponsiveYouTube.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveYouTube.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveYouTube.vue?vue&type=style&index=0&id=3881dedb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881dedb",
  null
  
)

export default component.exports